import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateMessageFormInput } from ".";
import MessageDto from "../../dto/Message/MessageDto";

const initialState: {
  open: boolean;
  loading: boolean;
  contractorId?: number;
  leadId?: number;
} = {
  open: false,
  loading: false,
};

const createMessageModalSlice = createSlice({
  name: "createMessageModal",
  initialState,
  reducers: {
    openModal(state, action: PayloadAction<{ contractorId?: number; leadId?: number }>) {
      state.open = true;
      state.contractorId = action.payload.contractorId;
      state.leadId = action.payload.leadId;
    },
    closeModal(state) {
      state.open = false;
      state.contractorId = undefined;
      state.leadId = undefined;
    },
    createMessage(state, _action: PayloadAction<CreateMessageFormInput>) {
      state.loading = true;
    },
    createMessageSuccess(state, _action: PayloadAction<MessageDto>) {
      state.open = false;
      state.loading = false;
    },
    createMessageReject(state) {
      state.loading = false;
    },
  },
});

export default createMessageModalSlice;
